import { useState } from "react";

import { Lab, PatientInsurance } from "pwapi";

import AdminPanel from "components/admin/adminPanel/AdminPanel";
import InsuranceWarningDialog from "components/admin/editCasePanel/InsuranceWarningDialog";
import HalfScreenPanel from "components/admin/editPanels/halfScreenEditPanel/HalfScreenPanel";
import DjangoLink from "components/DjangoLink";

import InsuranceForm from "./InsuranceForm";

type InsurancePanelProps = {
  setEditInsurance: Function;
  patientId: number;
  caseId: number;
  allowDelete?: boolean;
  primaryInsurance?: PatientInsurance;
  insurance: PatientInsurance;
  canUpdateInsurance?: boolean;
  insuranceLab?: Lab;
};

const InsurancePanel = ({
  setEditInsurance,
  insurance,
  patientId,
  caseId,
  allowDelete,
  primaryInsurance,
  canUpdateInsurance = true,
  insuranceLab,
}: InsurancePanelProps) => {
  const [delInsurance, setDelInsurance] = useState<PatientInsurance | null>(
    null
  );

  const handleOnClose = () => {
    setEditInsurance(null);
  };

  return (
    <>
      {delInsurance && (
        <InsuranceWarningDialog
          insurance={insurance}
          onCompleteDeletion={() => {
            setDelInsurance(null);
            handleOnClose();
          }}
          onClose={() => {
            setDelInsurance(null);
          }}
        />
      )}
      <HalfScreenPanel onClose={handleOnClose}>
        <div className="HalfScreen__container">
          <AdminPanel
            title={{
              prefix: `Insurance #${insurance.id || ""}`,
              main: `${
                insurance.id
                  ? insurance.primary_provider
                    ? "Primary"
                    : "Additional"
                  : "New"
              } Insurance`,
            }}
            djangoLink={
              <DjangoLink
                route={`pathology/patientinsurance/${insurance.id}/change/`}
                title="Django Insurance Access"
              />
            }
          >
            <InsuranceForm
              insurance={insurance}
              primaryInsurance={primaryInsurance}
              patientId={patientId}
              caseId={caseId}
              onDelete={
                allowDelete
                  ? () => {
                      setDelInsurance(insurance);
                    }
                  : undefined
              }
              onClose={handleOnClose}
              disableSubmit={!canUpdateInsurance}
              lab={insuranceLab}
            />
          </AdminPanel>
        </div>
      </HalfScreenPanel>
    </>
  );
};

export default InsurancePanel;
